import { isValidPhoneNumber } from "react-phone-number-input"

import { useFormik } from "formik"

import { TCancelReason } from "src/data/analytics/queries/planAnalyticsQueries"
import { useGetUser } from "src/data/user/hooks/useGetUser"

type TCancelFormFields = {
  experienceRating: number | null
  cancelReason: TCancelReason | null
  additionalFeedback: string
  returnProbability: number | null
  phoneNumber: string
}

export type TCancelPlanForm = ReturnType<typeof useCancelPlanForm>

export function useCancelPlanForm({ onSubmit }: { onSubmit: () => void }) {
  const user = useGetUser()

  const userPhoneNumber = user.phone_number ?? ""

  const form = useFormik<TCancelFormFields>({
    initialValues: {
      experienceRating: null,
      cancelReason: null,
      additionalFeedback: "",
      returnProbability: null,
      phoneNumber: isValidPhoneNumber(userPhoneNumber) ? userPhoneNumber : "",
    },
    validateOnMount: true,
    isInitialValid: false,
    onSubmit,
  })

  return form
}
